// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ProductSection from './components/ProductSection';
import PromoBanner from './components/PromoBanner';
import Newsletter from './components/Newsletter';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import ReturnPolicy from './components/ReturnPolicy';
import ShippingPolicy from './components/ShippingPolicy';
import CategoryPage from './components/CategoryPage';
import TrustedPartners from './components/TrustedPartners';
import HomeAbout from './components/HomeAbout';
// Pages
import ForgotPassword from './components/ForgotPassword';
import Login from './components/Login';
import Register from './components/Register';
import Cart from './components/Cart';
import Wishlist from './components/Wishlist';
import SearchResultsPage from './components/SearchResultsPage';
import HelpCenter from './components/HelpCenter';
import Careers from './components/Careers';
import News from './components/News';
import Investors from './components/Investors';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiesPolicy from './components/CookiesPolicy';
// NEW: Scroll helpers
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';
import ScrollToTopButton from './components/ScrollToTopButton';
import { getBestSellingProducts, getDiscountedProducts } from './data/products';
const HomePage = () => {
  const bestSellingProducts = getBestSellingProducts();
  const discountedProducts = getDiscountedProducts();
  return (
    <>
      <HeroSection />
      <HomeAbout />
      <CategoryGrid />
      <TrustedPartners />
      <ProductSection
        title="الأكثر مبيعاً"
        products={bestSellingProducts}
      />
      <PromoBanner />
      <ProductSection
        title="عروض وخصومات"
        products={discountedProducts}
      />
      <ContactUs/>
      <Newsletter />
    </>
  );
};
function App() {
  return (
    <Router>
      <CartProvider>
        <WishlistProvider>
          {/* NEW: يرجع لأعلى الصفحة أوتوماتيك مع كل تغيير راوت */}
          <ScrollToTopOnRouteChange />
          <Routes>
            <Route
              path="/"
              element={<MainLayout><HomePage /></MainLayout>}
            />
            {/* NEW: Route for search results page, using the imported component */}
            <Route path="/search" element={<MainLayout><SearchResultsPage /></MainLayout>} />
            <Route path="/category/:slug" element={<MainLayout><CategoryPage /></MainLayout>} />
            <Route path="/about-us" element={<MainLayout><AboutUs /></MainLayout>} />
            <Route path="/return-policy" element={<MainLayout><ReturnPolicy /></MainLayout>} />
            <Route path="/shipping-policy" element={<MainLayout><ShippingPolicy /></MainLayout>} />
            <Route path="/contact-us" element={<MainLayout><ContactUs /></MainLayout>} />
            <Route path="/login" element={<Login />} />

            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/wishlist" element={<MainLayout><Wishlist /></MainLayout>} />
            <Route path="/cart" element={<MainLayout><Cart /></MainLayout>} />
            {/* NEW: Help, company & legal pages linked from the footer */}
            <Route path="/help-center" element={<MainLayout><HelpCenter /></MainLayout>} />
            <Route path="/careers" element={<MainLayout><Careers /></MainLayout>} />
            <Route path="/news" element={<MainLayout><News /></MainLayout>} />
            <Route path="/investors" element={<MainLayout><Investors /></MainLayout>} />
            <Route path="/terms" element={<MainLayout><TermsAndConditions /></MainLayout>} />
            <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
            <Route path="/cookies-policy" element={<MainLayout><CookiesPolicy /></MainLayout>} />
          </Routes>
          {/* NEW: زرار الرجوع لأعلى الصفحة، ظاهر في كل الصفحات */}
          <ScrollToTopButton />
        </WishlistProvider>
      </CartProvider>
    </Router>
  );
}
export default App;
